module.exports = "/assets/data/1498017dc8e1d39dd87b7853c216ddc1-SP3.data.json";